import React from 'react'
import { styled } from '@mui/material/styles'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Box from '@mui/material/Box'
import { makeRequest } from '../../core/services/v1/request'
import Config from '../../core/config'

const Section = styled('section')(({ theme }) => ({
  backgroundColor: '#0E1116',
  padding: '80px 0',
  [theme.breakpoints.down('md')]: {
    padding: '60px 0',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '40px 0',
  },
}))

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: '#fff',
  marginBottom: '16px',
  fontSize: '3rem',
  [theme.breakpoints.down('md')]: {
    fontSize: '2.5rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '2rem',
  },
}))

const SectionDescription = styled(Typography)(({ theme }) => ({
  color: '#9AA6B2',
  fontSize: '1.1rem',
  marginBottom: '40px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
    marginBottom: '24px',
  },
}))

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: '1px solid #23262F',
  '&:not(:last-child)': {
    borderBottom: '1px solid #23262F',
  },
  '&:before': {
    display: 'none',
  },
  marginBottom: '16px',
  borderRadius: '12px',
  backgroundColor: '#0E1116',
  color: '#fff',
  '&.Mui-expanded': {
    backgroundColor: '#101318',
    borderRadius: '12px',
    border: '1px solid #21AB9D',
  },
}))

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<ExpandMoreIcon />} {...props} />
))(({ theme }) => ({
  backgroundColor: '#13161D',
  borderRadius: '12px',
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: '#fff',
  },
  '&.Mui-expanded': {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(180deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
  '&:hover .MuiAccordionSummary-content .MuiTypography-root': {
    color: '#21AB9D',
    textDecoration: 'underline',
  },
  '&:hover .MuiAccordionSummary-expandIconWrapper': {
    color: '#21AB9D',
  },
  padding: '0px 24px',
  minHeight: '64px',
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(3),
  borderTop: '1px solid #23262F',
  backgroundColor: '#13161D',
  borderBottomLeftRadius: '12px',
  borderBottomRightRadius: '12px',
}))

const QuestionText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.1rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  },
}))

const AnswerText = styled(Typography)(({ theme }) => ({
  color: '#9AA6B2',
  lineHeight: 1.6,
  fontSize: '1rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
  },
}))

function FAQ() {
  const [expanded, setExpanded] = React.useState(false)
  const [faqList, setfaqList] = React.useState([]);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }
    async function getFaq() {
    try {
      const params = {
        url: `${Config.V1_API_URL}faq/getfaq`,
        method: 'POST',
        body: { type: "common" }
      }
      const { status, data, error } = (await makeRequest(params));
      if (status && data) {
        setfaqList(data)
      }
    } catch (err) { }
  }
    React.useEffect(() => {
      getFaq();
    }, []);
  return (
    <Section>
      <div className='container'>
        <Box className='text-center' sx={{ mb: { xs: 3, md: 5 } }}>
          <SectionTitle variant='h2'>
            Frequently Asked{' '}
            <span
              style={{
                display: 'inline-block',
                backgroundImage: 'linear-gradient(to right, #21AB9D, #34d399)',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                color: 'transparent',
              }}
            >
              Questions
            </span>
          </SectionTitle>
          <SectionDescription variant='body1'>
            Everything you need to know about trading on Unitic.
          </SectionDescription>
        </Box>

        <div className='row justify-content-center'>
          <div className='col-lg-8'>
            {faqList.map((item, index) => (
              <Accordion
                key={index}
                expanded={expanded === `panel${index}`}
                onChange={handleChange(`panel${index}`)}
                sx={{
                  border:
                    expanded === `panel${index}`
                      ? '1px solid #333'
                      : '1px solid #23262F',
                }}
              >
                <AccordionSummary
                  aria-controls={`panel${index}d-content`}
                  id={`panel${index}d-header`}
                >
                  <QuestionText>{item?.title}</QuestionText>
                </AccordionSummary>
                <AccordionDetails>
                  <AnswerText>{item?.description}</AnswerText>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default FAQ
